// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    url: "images/photo.jpg",
    tag: "photos",
    info: "2022 canvas Film Festival:photos we love",
  },
  {
    url: "images/photo.jpg",
    tag: "photos",
    info: "2022 canvas Film Festival:photos we love",
  },
  {
    url: "images/photo.jpg",
    tag: "photos",
    info: "2022 canvas Film Festival:photos we love",
  },
];
